import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: ProductUpdateInput!
  ) {
    updateOneProduct(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fitofármaco actualizado`, mutationTypes.UPDATE)
)

